import { isBrowser } from "browser-or-node";
import Firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/performance";
// import 'firebase/database'

const config = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_DATABASE_URL,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
};

export const initFirebase = () => {
  // console.info("init with env", process.env);
  // must be called first
  if (Firebase.apps.length < 1) {
    console.info("Initializing Firebase");
    // must set settings before calling any firestore methods / initializing
    Firebase.initializeApp(config);
    // tried enablePerformance but it didn't work - the profile never loaded.
    // didn't debug futher.
    //
    if (isBrowser) {
      try {
        const newSettings = {
          ignoreUndefinedProperties: true,
        };
        console.log("updating firestore settings", newSettings);
        Firebase.firestore().settings(newSettings);
      } catch (e) {
        console.warn("unable to set firestore settings", e);
      }
      console.log("success setting firestore settings");
    }
    // Firebase.firestore().terminate
  } else {
    console.info(
      "Skipping Firebase initialization, an app is already initialized",
      Firebase.apps.length
    );
  }
};

// Init both Firebase and the admin
export const tryInit = () => {
  try {
    initFirebase();
  } catch (e) {
    console.info(
      "Firebase already initialized or else something went wrong",
      e
    );
  }
};

export const app = () => Firebase.apps.length > 0 && Firebase.apps[0];

initFirebase();
const db = Firebase.firestore();
const auth = Firebase.auth();
const storage = Firebase.storage();
const perf = isBrowser && Firebase.performance();
const firebase = Firebase;

// returns either a user or null if the user isn't logged in
const getUser = async () =>
  new Promise((resolve) => {
    auth.onAuthStateChanged((user) => {
      // console.log('onAuthStateChanged', user);
      if (user) {
        resolve(user);
      } else {
        // user is not logged in
        resolve(undefined);
      }
    });
  });

const verifyIdToken = (token) => {
  return auth.verifyIdToken(token).catch((error) => {
    console.warn("verifyIdToken", error);
    throw error;
  });
};

export { config, verifyIdToken, getUser, db, auth, storage, firebase, perf };
